export default __webpack_public_path__ + "static/media/r_puntos_go_logo.4815e310.svg";